'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// import Helmet from 'react-helmet';

// import { Glyphicon } from 'react-bootstrap';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _loginCookieUtils = require('../../helpers/loginCookieUtils');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Google Sign-In for Websites
// zdroj: https://developers.google.com/identity/sign-in/web/build-button
// inspired also by https://github.com/anthonyjgrove/react-google-login/blob/master/src/google.js
// jak autentifikovat backend server: https://developers.google.com/identity/sign-in/web/backend-auth

var javaScriptInitilized = false;

var GoogleLogin = (_dec = (0, _reactRedux.connect)(function (state) {
  return { authState: state.auth };
}, authActions), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(GoogleLogin, _Component);

  function GoogleLogin(props) {
    (0, _classCallCheck3.default)(this, GoogleLogin);

    var _this = (0, _possibleConstructorReturn3.default)(this, (GoogleLogin.__proto__ || (0, _getPrototypeOf2.default)(GoogleLogin)).call(this, props));

    _this.componentDidMount = function () {
      if (javaScriptInitilized) return;
      javaScriptInitilized = true;
      var createScriptElement = function createScriptElement(d, s, id, cb) {
        // eslint-disable-line
        var element = d.getElementsByTagName(s)[0];
        var fjs = element;
        var js = element;
        if (d.getElementById(id)) {
          return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = '//apis.google.com/js/platform.js';
        fjs.parentNode.insertBefore(js, fjs);
        js.onload = cb;
      };
      createScriptElement(document, 'script', 'google-login', function () {
        var params = {
          client_id: _this.props.clientId,
          cookiepolicy: 'single_host_origin'
        };
        window.gapi.load('auth2', function () {
          window.gapi.auth2.init(params);
          var cookieServiceName = (0, _loginCookieUtils.getServiceName)();
          // console.log('tlacitko pro Google Login bylo vykresleno.. ' + cookieServiceName);

          if (!window.agamaLogins) window.agamaLogins = {};

          window.agamaLogins.google = function (cb) {
            var options = {
              'scope': _this.props.scope
            };
            var auth2 = window.gapi.auth2.getAuthInstance();
            auth2.signIn().then(function () {
              if (auth2.isSignedIn.get(options)) {
                var idToken = auth2.currentUser.get().getAuthResponse().id_token;
                // console.log(idToken);
                // console.log('adresa pro serverove overeni je');
                // console.log('https://www.googleapis.com/oauth2/v3/tokeninfo?id_token=' + idToken);
                // na serveru verifikovat vše dle viz https://developers.google.com/identity/sign-in/web/backend-auth
                // dale není třeba:
                // const profile = auth2.currentUser.get().getBasicProfile();
                // console.log(profile);
                if (cb) cb(idToken);else _this.props.login(idToken, 'google');
              }
            });
          };

          var prihlasitAutomaticky = cookieServiceName === 'google';
          if (prihlasitAutomaticky) {
            _this.onBtnClick();
          }
        });
      });
    };

    _this.onBtnClick = function () {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (event) event.preventDefault();
      window.agamaLogins.google();
    };

    _this.render = function () {
      var styles = require('./LoginMenu.scss');
      return (//   <img src="/4_free.jpg"/>
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'button',
            { className: styles.btnLogin + ' ' + styles.btnGoogle,
              onClick: _this.onBtnClick },
            _this.props.textButton
          )
        )
      );
    };

    return _this;
  }
  // handleSubmit = (event) => {
  //   event.preventDefault();
  //   const input = this.refs.username;
  //   this.props.login(input.value);
  //   input.value = '';
  // }

  // const onSignIn = (googleUser) => {
  //   const profile = googleUser.getBasicProfile(); // eslint disable
  //   console.log('ID: ' + profile.getId()); // Don't send this directly to your server!
  //   console.log('Name: ' + profile.getName());
  //   console.log('Image URL: ' + profile.getImageUrl());
  //   console.log('Email: ' + profile.getEmail());

  //   // The ID token you need to pass to your backend:
  //   const idToken = googleUser.getAuthResponse().id_token;
  //   console.log('ID Token: ' + idToken);
  // };
  // alert('inixxx');
  //   // window.onSignIn = onSignIn;
  //   javaScriptInitilized.value = true;
  // }

  return GoogleLogin;
}(_react.Component), _class2.propTypes = {
  textButton: _react.PropTypes.string,
  clientId: _react.PropTypes.string.isRequired,
  scope: _react.PropTypes.string,
  redirectUri: _react.PropTypes.string,
  offline: _react.PropTypes.bool,

  authState: _react.PropTypes.object,
  login: _react.PropTypes.func
}, _class2.defaultProps = {
  textButton: 'Login with Google',
  scope: 'profile email',
  redirectUri: 'postmessage'
}, _temp)) || _class);
exports.default = GoogleLogin;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Logins/GoogleLogin.js
// module id = 1182
// module chunks = 0